import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
    count: 0,
    marketSelect: {},
    competitionSelect: 0,
    sport: null,
    fixtureTimeperiod: '',
    listCompetitionFavourites: 0,
    fixtureCompetitions: [],
    activeMarket: 0,
    removeMarket: 0,
    updateMarket: [],
    activeMatch: 0,
    removeMatch: 0,
    updateMatch: [],
    selectMatch: [],
    betslip: [],
    addBet: []
}
const mutations = {
    addBet (state, payload) {
        state.addBet = payload;
    },
    updateCurrentMatch (state, payload) {
        state.selectMatch = payload;
    },
    updateFixtureCompetitions (state, payload) {
        state.fixtureCompetitions = payload;
    },
    updateListCompetitionFavourites (state, payload) {
        state.listCompetitionFavourites = payload;
    },
    updateFixtureTimeperiod (state, payload) {
        state.fixtureTimeperiod = payload;
    },
    updateSport (state, payload) {
        state.sport = payload;
    },
    updateMarketSelect (state, payload) {
        state.marketSelect = payload;
    },
    updateCompetitionSelect (state, payload) {
        state.competitionSelect = payload;
    },
    updateActiveMarket (state, payload) {
        state.activeMarket = payload;
    },
    removeMarket (state, payload) {
        state.removeMarket = payload;
    },
    updateMarket (state, payload) {
        state.updateMarket = payload;
    },
    removeMatch (state, payload) {
        state.removeMatch = payload;
    },
    updateMatch (state, payload) {
        state.updateMatch = payload;
    },
    updateBetslip (state, payload) {
        state.betslip = payload;
    },
}
export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/store.js